import { Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import classes from "./Login.module.css";
import { useMutation } from "react-query";
import { login } from "../../utils/api/auth/login";
import { useAuthDataContext } from "../../utils/storages/authDataProvider";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";
import { useEffect } from "react";

const Login = () => {
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => loginMutation.mutate(data);
  const navigate = useNavigate();

  const { onLogin } = useAuthDataContext();

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (localStorage.getItem("user")) {
      navigate("/panel");
    }
  }, []);

  const loginMutation = useMutation("login-mutation", (data) => login(data), {
    onSuccess: (data) => {
      let userData = {
        user: { tk: data?.data?.authorisation?.token },
      };
      localStorage.setItem("user", JSON.stringify(userData));
      onLogin(userData);
      navigate("/panel");
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.message ?? "خطا در ورود به پنل", { variant: "error" });
    },
  });

  return (
    <Grid container alignItems={"center"} justifyContent={"center"} style={{ height: "100vh" }}>
      <Grid item>
        <Paper style={{ padding: 20 }}>
          <Grid container direction={"column"}>
            <Grid item xs={12}>
              <Typography variant='h3'>ورود</Typography>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 20 }}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Controller
                  name='username'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={errors.username}
                      helperText={errors.username && "نام کاربری الزامی است."}
                      className={classes.textFields}
                      disabled={loginMutation.isLoading}
                      variant='outlined'
                      label='نام کاربری'
                      margin='dense'
                      fullWidth
                    />
                  )}
                />

                <Controller
                  name='password'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={errors.password}
                      helperText={errors.password && "رمز عبور الزامی است."}
                      className={classes.textFields}
                      disabled={loginMutation.isLoading}
                      variant='outlined'
                      label='رمز عبور'
                      margin='dense'
                      type='password'
                      fullWidth
                    />
                  )}
                />
                <Button
                  variant='contained'
                  fullWidth
                  size='large'
                  type='submit'
                  style={{ marginTop: 20 }}
                  onClick={handleSubmit(onSubmit)}
                  loading={loginMutation.isLoading}
                  disabled={loginMutation.isLoading}
                >
                  ورود
                </Button>
              </form>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Login;
